/**
 * A shop picture drawn in its size's own shape (studio-shop D3; shop-catalog
 * "Each size has its picture"). The picture is the service's preview of the
 * option's print file (Printful's: the print file's flat front view, never a
 * store mockup), and sizes made from one print file share it in that file's
 * proportions. So it fills a box in the size's proportions ("18 × 24 in" draws
 * 18:24), as large as the slot allows, cropped to it as the print itself is cut.
 * A size that does not read as width × height shows the whole picture. No
 * border of its own: a paper print's white border is in its picture. A canvas picture that also covers the wrap
 * around the stretcher shows its front only (canvasWrap).
 */
import { useState, type CSSProperties } from 'react';

import { canvasWrap, canvasWrapStyle } from './canvasWrap';
import css from './PrintPicture.module.css';

const SIZE = /^(\d+(?:\.\d+)?) × (\d+(?:\.\d+)?) in$/;

export function PrintPicture({ url, alt, size, canvas = false, className = '' }: { url: string; alt: string; size: string | null; canvas?: boolean; className?: string }) {
  const shape = size ? SIZE.exec(size) : null;
  const [front, setFront] = useState<{ url: string; style: CSSProperties } | null>(null);
  const onLoad = (event: React.SyntheticEvent<HTMLImageElement>) => {
    if (!canvas || !shape) return;
    const wrap = canvasWrap(event.currentTarget.naturalWidth, event.currentTarget.naturalHeight, Number(shape[1]), Number(shape[2]));
    setFront(wrap ? { url, style: canvasWrapStyle(wrap) } : null);
  };
  return (
    <span className={`${css.slot} ${className}`}>
      {shape ? (
        <span className={css.box} style={{ '--w': shape[1], '--h': shape[2] } as CSSProperties}>
          <img src={url} alt={alt} loading="lazy" onLoad={onLoad} style={canvas && front?.url === url ? front.style : undefined} />
        </span>
      ) : (
        <img className={css.whole} src={url} alt={alt} loading="lazy" />
      )}
    </span>
  );
}
